export class FinallUserInvitationsModel {
    email?: string;
    role: number;
    language: string;
}
